import { Button } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'

import { forceRedirect } from '@methods/forceRedirect'
import { API_URL } from '@constants/apiUrl'
import { Illustration } from '@/components/Illustration/Illustration'

export const CompleteIkanoPage = observer(() => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { completePage: trans } = store.TranslationsState.translationsNew

  const [disabled, setDisabled] = useState(false)

  const handleProceed = () => {
    setDisabled(true)
    forceRedirect(`${API_URL}/micropayment/complete?status=success`)
  }

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      {!isMobile ? (
        <>
          <Illustration type="success" />
          <p className="generic__paragraph-centered m-0-0-30">{trans.message}</p>
        </>
      ) : (
        <>
          <Illustration type="success" />
          <p className="generic__paragraph-centered m-0-0-30">{trans.message}</p>
        </>
      )}
      <div className="layout__content-container-bottom-fixed-centered">
        <div className="layout__vertically-centered-container">
          <Button
            disabled={disabled}
            onClick={handleProceed}
            id="page-submit"
            type="submit"
            className="button--proceed"
          >
            <span className="generic__button-text">{trans.submit}</span>
          </Button>
        </div>
      </div>
    </div>
  )
})
